import { type FC, type ReactNode, useEffect } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { logger } from '@zep/core-logger';
import { isErrorBoundarySuppressedError } from '@/api/apiUtil';
import { ErrorBoundaryFallback } from './ErrorBoundaryFallback';
const Fallback: FC<FallbackProps> = ({
  error,
  resetErrorBoundary
}) => {
  const {
    reset
  } = useQueryErrorResetBoundary();
  if (isErrorBoundarySuppressedError(error)) {
    resetErrorBoundary();
    reset();
    return;
  }
  return <ErrorBoundaryFallback className="fixed top-1/2 -translate-y-1/2" error={error} data-sentry-element="ErrorBoundaryFallback" data-sentry-component="Fallback" data-sentry-source-file="GlobalErrorBoundary.tsx" />;
};
const GlobalErrorBoundary = ({
  children
}: Props) => {
  return <ErrorBoundary FallbackComponent={Fallback} onError={(error, _) => {
    logger.captureError(error, {
      attributes: {
        source: 'GlobalErrorBoundary'
      }
    });
  }} data-sentry-element="ErrorBoundary" data-sentry-component="GlobalErrorBoundary" data-sentry-source-file="GlobalErrorBoundary.tsx">
      {children}
    </ErrorBoundary>;
};
export default GlobalErrorBoundary;
type Props = {
  children: ReactNode;
};
export const useUnhandledRejectionErrors = (handler: Handler) => {
  useEffect(() => {
    window.addEventListener('unhandledrejection', handler);
    return () => {
      window.removeEventListener('unhandledrejection', handler);
    };
  }, [handler]);
};
type Handler = (event: PromiseRejectionEvent) => void;